<template>
  <div id="app-container">
    <mobile-app-gate v-if="showMobileAppGate"/>
    <router-view v-else-if="appReady" v-loading.fullscreen.lock="!appReady"/>
  </div>
</template>

<script>
import Auth from "@/services/Auth"
import {fetchEntities} from "@/services/entity-loader"
import {modules} from "@/modules.js"
import MobileAppGate from "@/components/mobile-app-gate"
import {detectMobilePlatform} from "@/services/mobile-app"

import Contexts from "@/mixins/contexts"
import {actionRefreshToken} from "@/services/http";

export default {
  components: {
    MobileAppGate,
  },
  mixins: [
    Contexts
  ],
  data() {
    return {
      mobilePlatform: detectMobilePlatform(),
      webAppInitialized: false,
    }
  },
  computed: {
    appReady() {
      return this.$store.getters["App/getState"]
    },
    transition() {
      return this.$store.getters["Router/getTransition"]
    },
    showMobileAppGate() {
      return Boolean(this.mobilePlatform)
    },
    module: {
      get: function () {
        return this.$store.getters["App/getModule"]
      },
      set: function (val) {
        this.$store.dispatch("App/actionSetModule", val)
      }
    },
  },
  watch: {
    "$route.path": {
      handler: function (val, oldVal) {
        let module = val.split("/")[1]
        this.module = Object.keys(modules).find(key => key === module)
        if (oldVal === "/login") {
          this.loadProfile()
        }
      },
      immediate: true,
    }
  },
  created() {
    if (this.showMobileAppGate) {
      return
    }

    this.initializeWebApp()
  },
  methods: {
    initializeWebApp() {
      if (this.webAppInitialized) {
        return
      }

      this.webAppInitialized = true
      this.$store.dispatch("WidthToggle/actionInitWidth")
      this.$store.dispatch("Theme/actionInitTheme")
      this.loadProfile()
      this.resizePage()
    },
    loadProfile() {
      if (Auth.isAuthenticated()) {
        this.$store.dispatch("App/actionSetState", false)
        this.$store.dispatch("Contexts/actionInitContexts")
        Auth.loadProfile().then(data => {
          if (data) {
            this.afterLoadProfile(data)
          } else {
            Auth.logout()
          }
        }).catch((e) => {
          if (e && e.response && [401].includes(e.response.status)) {
            actionRefreshToken().then((res) => {
              this.$store.dispatch("Auth/actionSetTokens", res.data)
              this.loadProfile()
            }).catch((e) => {
              Auth.logout()
              throw e
            })
          }
          else if (e === "LOGOUT") {
            Auth.logout()
          }
          throw e
        })
      }
    },
    afterLoadProfile(data) {
      if (data.id) {
        let organizationId = data.organizationIds ? data.organizationIds[0] : data.organizationId
        if (data.organizationIds.find(id => id === this.$store.getters["Contexts/getOrganization"])) {
          organizationId = this.$store.getters["Contexts/getOrganization"]
        }
        let organizationsGroupId = null
        if (data.organizations && data.organizations[0]) {
          organizationsGroupId = data.organizations.find(o => o.id === organizationId)?.organizationsGroupId
        }
        this.$store.dispatch("Contexts/actionSetOrganization", {val: organizationId})
        this.$store.dispatch("Contexts/actionSetOrganizationsGroupId", {val: organizationsGroupId})
        fetchEntities(["userorganizations"], () => {
          this.$store.dispatch("App/actionSetOrganizationType")
          this.$store.dispatch("App/actionSetState", true)
          this.$store.dispatch("Contexts/actionSetOrganizationGuid")
          this.$store.dispatch("Contexts/actionSetOrganizationsGroupGuid")
        })
      } else {
        this.$message({
          showClose: false,
          duration: 5000,
          message: "Пользователь не зарегистрирован",
          type: "error"
        })
      }
    },
    resizePage() {
      let isMobile = window.innerWidth <= 820
      this.$store.dispatch("App/actionSetIsMobile", isMobile)
    },
  }
}
</script>
